module.exports = __webpack_public_path__ + "img/1_020.c0206e2b.jpg";